import { GetStaticProps } from 'next';
import { LinkButton, bffService } from '@thisisdevelopment/akzonobel-core';
import { ContainerInner, Page, Wysiwyg, PageType } from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { pageRevalidate } from '../../../src/config';
import { PageButtonContainer } from 'components/Button';

type SSRProps = {
  page: PageType;
};

const categoryName = 'articles';

function Articles({ page }: SSRProps) {
  const meta = metas.default;

  return (
    <div>
      <NextHead meta={meta} />
      <Page title={page.title}>
        <ContainerInner>
          <Wysiwyg content={page.text} />
          <PageButtonContainer>
            <div>
              {page.button_link && page.button_label && (
                <LinkButton href={page.button_link}>{page.button_label}</LinkButton>
              )}
            </div>
          </PageButtonContainer>
        </ContainerInner>
      </Page>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const page = await bffService
    .getCmsItemBySlug(categoryName, params?.slug as string)
    .then((r) => r.data.data);
  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export async function getStaticPaths() {
  const pages = await bffService.getCmsItem(categoryName).then((r) => r.data.data);
  const paths = pages.map((p: PageType) => ({
    params: { slug: p.slug },
  }));
  return {
    paths,
    fallback: false,
  };
}

export default Articles;
